export default [
  {
    to: '/',
    title: 'Facebook',
    icon: 'fab fa-facebook-f'
  },
  {
    to: '/',
    title: 'Instagram',
    icon: 'fab fa-instagram'
  },
  {
    to: '/',
    title: 'Email',
    icon: 'fas fa-envelope'
  }
]
